import { render } from "./view.vue?vue&type=template&id=aff666fe&ts=true"
import script from "./view.vue?vue&type=script&lang=ts"
export * from "./view.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Pages/Admin/Plays/Options/view.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "aff666fe"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('aff666fe', __exports__)) {
    api.reload('aff666fe', __exports__)
  }
  
  module.hot.accept("./view.vue?vue&type=template&id=aff666fe&ts=true", () => {
    api.rerender('aff666fe', render)
  })

}


export default __exports__